module.exports = __webpack_public_path__ + "static/hero-image-mobile-653dce9922ccb8333c8af19b359f4dd9.png";